@if (showEmailSentDialog$ | async) {
  <dcr-dialog
    open
    headline="E-mail verzonden"
    icon="portal:mail"
    type="confirm"
    (confirm)="onEmailSentDialogConfirm()"
    data-cy="request-sent-message"
  >
    <div>Check je inbox: er is een e-mail gestuurd naar het opgegeven e-mailadres om je wachtwoord opnieuw in te stellen.</div>
  </dcr-dialog>
}

<div class="[ relative container container-max-width-3xl stack ]">
  <h1 *ngIf="mode !== 'forgot-password'" class="[ headline-large text-center ]" data-cy="form-header">
    <ng-container *ngIf="(role$ | async) === 'schooladmin'; else standardLoginTitle">Aanmelden als schoolbeheerder</ng-container>
    <ng-template #standardLoginTitle>Aanmelden</ng-template>
  </h1>
  <h1 *ngIf="mode === 'forgot-password'" class="[ headline-large text-center ]" data-cy="form-header">Wachtwoord vergeten</h1>

  <campus-maintenance-mode
    *ngIf="isMaintenanceMode$ | async; else operationalMode"
    [statusPageUrl]="statusPageUrl"
  ></campus-maintenance-mode>
  <ng-template #operationalMode>
    <dcr-animated-kai
      #kai
      src="assets/rive/kai_state_machine.riv"
      autoplay
      track-lookat
      react-to-click
      class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
    ></dcr-animated-kai>

    <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
      <div class="[ p-b-m ]" *ngIf="mode !== 'sso'">
        <polpo-login-form
          *ngIf="mode === 'basic-login'"
          (login)="loginWithCredentials($event)"
          [showRegister]="(role$ | async) !== 'schooladmin'"
          (forgotPassword)="setForgotPasswordMode()"
          [error]="loginError$ | async"
        ></polpo-login-form>
        <polpo-forgot-password-form
          *ngIf="mode === 'forgot-password'"
          (whenSubmitted)="resetPassword($event)"
          [showRegister]="(role$ | async) !== 'schooladmin'"
          (whenCancelled)="setLoginMode()"
          [passwordResetRequested]="passwordResetRequested$ | async"
        ></polpo-forgot-password-form>
      </div>

      <div class="[ border-1 p-b-m ]" [class.border-bs]="mode !== 'sso'" *ngIf="(role$ | async) !== 'schooladmin'">
        <polpo-login-methods
          (login)="loginWith($event)"
          (whenCancelled)="setLoginMode()"
          [provider]="provider$ | async"
          [error]="ssoError$ | async"
        ></polpo-login-methods>
      </div>

      <div class="[ border-1 border-bs p-b-m ]">
        <polpo-login-no-access [role]="role$ | async" data-cy="login-no-access"></polpo-login-no-access>
      </div>
    </div>
  </ng-template>
</div>
